
import React from "react";
import { Classname } from "@rivtn/noseur";
import { useInView } from "../../hooks";
import { i18nManager } from "../../i18n";
import { splitName } from "../../helpers";
import styles from "../../assets/style.module.css";
import { i18nManager as globalI18nManager } from "../../../../../i18n";
import { IProfileWebsite, ITeamHistory, Status } from "../../../../../services";

export interface IntroProps {
    website: IProfileWebsite;
    teamHistories: ITeamHistory[];
}

function Intro({ website, teamHistories }: IntroProps) {

    const [ref, inView] = useInView();
    const labels = i18nManager.Labels;
    const { last } = splitName(website.display_name);
    const currentTeam = teamHistories.find((t) => t.status === Status.ACTIVE);
    const stats = (website.home_settings?.show_stats && website.extra_data?.stats) ? Object.entries(website.extra_data.stats).slice(0, 4) : [];
    const facts = ([
        [labels.facts.username, `@${website.member.username}`],
        [labels.facts.age, website.member.age],
        [labels.facts.country, website.member.country_code ? globalI18nManager.queryCountryCurrency(website.member.country_code, "country_code", "country_name") : null],
        [labels.facts.current_team, currentTeam?.name],
        [labels.facts.teams, teamHistories.length || null],
        [labels.facts.member_since, website.created_at ? new Date(website.created_at).getFullYear() : null],
    ] as [string, React.ReactNode][]).filter(([_, v]) => v !== null && v !== undefined && v !== "");

    return (<section className={Classname.build(styles["section"], styles["bg-ink"])}>
        <div ref={ref} className={Classname.build(styles["container"], styles["intro"], styles["reveal"], { [styles["in-view"]]: inView })}>
            <div>
                <div className={styles["kicker"]}>{labels.home.bio_kicker}</div>
                <h2 className={styles["title"]}>{labels.home.bio_title} <em>{last}</em></h2>
                {website.profile_detail && (<p className={styles["intro-text"]}>{website.profile_detail}</p>)}
                {stats.length > 0 && (<div className={styles["stats"]}>
                    {stats.map(([k, v]) => (<div key={k}>
                        <div className={styles["stat-val"]}>{v as React.ReactNode}</div>
                        <div className={styles["stat-lbl"]}>{k.replaceAll("_", " ")}</div>
                    </div>))}
                </div>)}
            </div>
            {facts.length > 0 && (<div className={styles["facts"]}>
                {facts.map(([k, v]) => (<div key={k} className={styles["fact"]}>
                    <span className={styles["fact-key"]}>{k}</span>
                    <span className={styles["fact-val"]}>{v}</span>
                </div>))}
            </div>)}
        </div>
    </section>);
}

export default Intro;
